import React, { Suspense } from 'react'
import Media from 'react-media'
import { SIZES } from 'src/styles/theme'
import MobileGame from './MobileGame'

const GamePage: React.FC = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Media query={`(max-width: ${SIZES.mobileBreakpoint})`}>{(matches) => (matches ? <MobileGame /> : <MobileGame />)}</Media>
    </Suspense>
  )
}

export default GamePage
